var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5Pin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7512_41756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.006 491.042C103.05 289.904 78 269.261 78 195.34C78 94.0838 157.842 12 256.333 12C354.824 12 434.666 94.0838 434.666 195.34C434.666 269.261 409.616 289.904 274.661 491.042C265.804 504.195 246.861 504.194 238.006 491.042Z",
    fill: "#E9C7D6"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.299 174.459C268.287 174.459 265.421 175.892 264.274 179.044C263.128 182.197 262.555 187.929 262.555 196.24V199.679C262.555 208.85 263.128 214.582 264.561 217.448C265.994 220.314 268.573 221.747 272.872 221.747C277.171 221.747 279.75 220.314 280.897 217.735C282.043 215.155 282.616 209.424 282.616 201.112V196.527C282.616 187.929 282.043 182.197 280.61 179.044C279.177 175.892 276.311 174.459 272.299 174.459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.821 71C186.319 71 129 128.319 129 198.821C129 269.324 186.319 326.643 256.821 326.643C327.324 326.643 384.643 269.324 384.643 198.821C384.643 128.032 327.61 71 256.821 71ZM344.806 153.826L342.8 214.011H322.452L321.019 153.826H344.806ZM229.308 240.664H212.686L210.393 236.079H209.82C208.1 237.512 206.954 238.371 206.094 238.945C203.515 240.951 199.789 241.811 195.203 241.811C175.715 241.811 165.971 227.194 165.971 197.675C165.971 183.059 168.55 171.595 173.709 163.857C178.868 156.119 187.465 152.106 199.502 152.106C209.247 152.106 217.558 153.539 224.436 156.692L220.71 179.333C211.826 176.753 205.234 175.321 201.222 175.321C197.21 175.321 194.344 177.04 192.624 180.766C191.191 184.492 190.331 190.223 190.331 197.962C190.331 205.7 191.191 211.431 192.624 215.157C194.057 218.883 196.923 220.602 201.508 220.602C202.941 220.602 205.234 220.316 208.96 219.456V208.852H202.655V192.23H229.308V240.664ZM298.378 230.92C292.932 238.371 284.334 242.097 272.011 242.097C259.974 242.097 251.089 238.371 245.931 231.207C240.485 223.755 237.906 212.291 237.906 196.815C237.906 181.339 240.485 170.162 245.931 162.997C251.376 156.119 259.974 152.393 272.297 152.393C284.621 152.393 293.219 155.832 298.378 162.71C303.536 169.589 306.402 180.766 306.402 196.242C306.689 212.005 303.823 223.468 298.378 230.92ZM333.056 242.097C324.744 242.097 320.732 238.371 320.732 231.207C320.732 227.481 321.592 224.615 323.598 222.895C325.604 221.176 328.757 220.029 333.056 220.029C337.354 220.029 340.507 220.889 342.513 222.895C344.519 224.615 345.379 227.481 345.379 231.493C345.379 238.658 341.367 242.097 333.056 242.097Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7512_41756",
    x: 74,
    y: 12,
    width: 364.664,
    height: 496.906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7512_41756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7512_41756",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Pin);
export default __webpack_public_path__ + "static/media/5-pin.0f80a0aba60d2fe6f8d7fc4201a64b87.svg";
export { ForwardRef as ReactComponent };